import React, { useEffect, useState } from "react";
import {getDatabase, onValue, ref, set as firebaseSet} from 'firebase/database';

export function Schedule(props) {
  // console.log(props.uid);
  const activities = ['Eat Meals', 'Walk the Dog', 'Go to Class', 'Study', 'Workout'];
  const times = ['00:00 AM', '01:00 AM', '02:00AM', '03:00AM', '04:00 AM',
  '05:00 AM', '06:00 AM', '07:00 AM', '08:00 AM', '09:00 AM', '10:00 AM', '11:00 AM', '12:00 PM', '01:00 PM', '02:00PM', '03:00PM', '04:00 PM',
  '05:00 PM', '06:00 PM', '07:00 PM', '08:00 PM', '09:00 PM', '10:00 PM', '11:00 PM', '12:00 AM']
  const jsonData = {};
  activities.forEach(function(activity) {
    times.forEach(function(time) {
      jsonData[activity + '-' + time] = false;
    })
  })
  const [scheduleStatus, setScheduleStatus] = useState(jsonData);
  useEffect(() => {
    const db = getDatabase();
    const currentDate = new Date(Date.now());
    const userDayRef = ref(db, "dayTracker/" + props.uid);
    const offFunction = onValue(userDayRef, (snapshot) => {
      // console.log(snapshot);
      const newValue = snapshot.hasChild(currentDate.toDateString());
      // console.log(newValue);
      if(newValue) {
        const userDayRefInfo = ref(db, "dayTracker/" + props.uid + '/' + currentDate.toDateString());
        const dayInfoOffFunction = onValue(userDayRefInfo, (snapshot) => {
          setScheduleStatus(snapshot.val());
          // console.log(snapshot.val());
        })
        dayInfoOffFunction();
      } else {
        const userDayRefInfo = ref(db, "dayTracker/" + props.uid + '/' + currentDate.toDateString());
        firebaseSet(userDayRefInfo, jsonData);
        setScheduleStatus(jsonData);
      }
    })
    function cleanup() {
      offFunction();
    }
    return cleanup;
  }, [])

  const tdRows = times.map(function(n) {
    return <TableRows key={ n } time={ n } activities={ activities } scheduleStatus={scheduleStatus}/>
  })
  return (
    <div className = "container">
    <h1 className="text-center">Welcome to <em>Get Your Life Together!</em></h1>
    <div className="calendar-container">
        <div className="day-container">
            <Time/>
        </div>
        <div className="time-container">
            <table>
                <TableHeaders activities={ activities }/>
                <tbody>
                  { tdRows }
                </tbody>
            </table>
        </div>
    </div>
</div>
  )

  function Time() {
    const date = new Date(Date.now());
    const stringDate = date.toDateString();

    return (<h3 className="date">{stringDate}</h3>);

  }
    // Figure out how to add right-side className to last table head element
  function TableHeaders(props) {
    const activities = props.activities;
    const headers = activities.map(function(n) {
      return <th key={ n } scope='col' className="">{ n }</th>
    });
    // console.log(headers[headers.length - 1]);
    //headers[headers.length - 1].className= "right-side";


    return(
      <thead>
        <tr>
          <th className= "left-side" scope="col">Time</th>
          { headers }

        </tr>
      </thead>
    )
  }

  function TableRows(props) {
    const time = props.time;
    const activities = props.activities;
    //console.log(scheduleStatus);
    const tdRows = activities.map(element => {
      //console.log(element);
      // console.log(props.scheduleStatus[element + '-' + time])
      if(props.scheduleStatus[element + '-' + time]) {
        return <td onClick={selectTime} id={element + '-' + time} key={element + '-' + time} className={'td-shade'}></td>
      } else {
        return <td onClick={selectTime} id={element + '-' + time} key={element + '-' + time}></td>
      }
    });
    //console.log(tdRows);

    return(
      <tr>
        <td scope="row" className="timeslot"> { time }</td>
        { tdRows }
      </tr>
    )
  }

  function selectTime(event) {
    const db = getDatabase();
    const currentDate = new Date(Date.now());
    const userDayRef = ref(db, "dayTracker/" + props.uid + '/' + currentDate.toDateString());
    // console.log(currentDate.toDateString());
    // console.log('event: ' + event);
    // console.log('event target: ' + event.target);
    // console.log(event.target.id);
    // console.log(scheduleStatus);
    // console.log(scheduleStatus[event.target.id]);
    const scheduleStatusCopy = {...scheduleStatus};
    scheduleStatusCopy[event.target.id] = !scheduleStatusCopy[event.target.id];
    setScheduleStatus(scheduleStatusCopy);
    // console.log(scheduleStatus);
    firebaseSet(userDayRef, scheduleStatusCopy);
    /*event.target.classList.toggle('td-shade');*/
  }

}
